// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fux9","clinicsSelect":"styles_clinicsSelect__3ajQE"};